import React from 'react'

const PlanViejo = () => {
  return (
    <div className='seccion'>		
    
  <h1>PROGRAMAS DE ESTUDIOS - Viejo diseño curricular</h1>

        <h4>Viejo diseño curricular - 1er, 2do y 3er año</h4>	
    
    <div className="contenedor-tablas">
    <table className="tabla-programas">
        <caption>1er Año</caption>
        <tr>

            <th>Materia</th>
            <th>Programa</th>

        </tr>
        <tr>

            <td>Lengua y Literatura</td>
            <td><a href="https://drive.google.com/drive/folders/1Jab3vp1oj5tsZ-4n8cDhgLbXnF8QYlbP?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Matematica</td>
            <td><a href="https://drive.google.com/drive/folders/1FT567ibD7LnN2gmOjvS78-3YBgM8KZBF?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Idioma Extranjero Ingles o Frances</td>
            <td><a href="https://drive.google.com/drive/folders/1xFQSZMB-IwsFaXbg7MWnmiD5GbnkZUCy?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Ciencias Biologicas</td>
            <td><a href="https://drive.google.com/drive/folders/1ikopp1s7zdmCnXd8pTCZT_vOt2QeqANI?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Edicacion Plastica</td>
            <td><a href="https://drive.google.com/drive/folders/10V6Ea3saGswoIlEd6T5_3GpjPZNOUXz7?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Geografia</td>
            <td><a href="https://drive.google.com/drive/folders/1612KMQZ7dB7P94-pvdAirXz5xKJ9h5Tk?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Musical</td>
            <td><a href="https://drive.google.com/drive/folders/1ivuQt3nwo22UAdvXU9_0HfFF8l8VtBLk?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Civica</td>
            <td><a href="https://drive.google.com/drive/folders/1p4_qfugq4AYDw-im2oD1fjP7ArzwcdOX?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Historia</td>
            <td><a href="https://drive.google.com/drive/folders/1SahRKtih2M9NjBDqjwA-652SGcRORBjb?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Ciencias Fisico Quimica</td>
            <td><a href="https://drive.google.com/drive/folders/1_Gtm2geAbXmiLo43r1T2-abgMZcSjTKx?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Contabilidad</td>
            <td><a href="https://drive.google.com/drive/folders/1C6CsDd626slGnsp-68er8AjqcTVW1PPv?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Fisica</td>
            <td><a href="https://drive.google.com/drive/folders/1IfJoN4pU1gTtYAyrz1fPQ2XUh1HSwhuw?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Practica - Taller I</td>
            <td><a href="https://drive.google.com/drive/folders/1W3ka1sgfdiPogTgwj9brrqjHZXBySjE_?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>

    </table>
    <table className="tabla-programas">
        <caption>2do Año</caption>
        <tr>

            <th>Materia</th>
            <th>Programa</th>

        </tr>
        <tr>

            <td>Lengua y Literatura</td>
            <td><a href="https://drive.google.com/drive/folders/1bwPsAlljOEYdHBDPI2CF7CtTiLO0X79L?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Matematica</td>
            <td><a href="https://drive.google.com/drive/folders/1FGq9kkMElpmKCbWJ-slMoNp-XR0WN_8G?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Idioma Extranjero Ingles o Frances</td>
            <td><a href="https://drive.google.com/drive/folders/1GqWL6mwLUhFTAJos_IF828Uw3-ibh1K7?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Ciencias Biologicas</td>
            <td><a href="https://drive.google.com/drive/folders/1uxJQ9pVLhRTTggjCsYvRD8-yU_TyM0go?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Edicacion Plastica</td>
            <td><a href="https://drive.google.com/drive/folders/1MBW3mEYi9OxsWEdibhBVjLRm9ddm8U0r?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Geografia</td>
            <td><a href="https://drive.google.com/drive/folders/1cFjheJ95BNh5YMWIQMCcEZV4NbMsHVLJ?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Musical</td>
            <td><a href="https://drive.google.com/drive/folders/1toC15Qpck6pF7fu6VJzUKKEQE2Gj9Q3S?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Civica</td>
            <td><a href="https://drive.google.com/drive/folders/1q-0zOdpADZrt7sMthCLtcF7722LYwOQF?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Historia</td>
            <td><a href="https://drive.google.com/drive/folders/1kgmj0VP5VDdRJgS9FMnw4XEr78uhNDTM?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Ciencias Fisico Quimica</td>
            <td><a href="https://drive.google.com/drive/folders/1Cx013F93mJzwwJnrrq6CLrAkVayc4T5a?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Contabilidad</td>
            <td><a href="https://drive.google.com/drive/folders/1tTt56zthibxqM66SDbf6XrmGvaRXVmsa?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Fisica</td>
            <td><a href="https://drive.google.com/drive/folders/1ZsAEZUEc0PyEHiOI1VDBlGIsD9TSjWpP?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>
        
        <tr>

            <td>Educacion Practica - Taller I</td>
            <td><a href="https://drive.google.com/drive/folders/1wc8turoWwmPIRpr07SuF7G2aHWJTkTNs?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

        </tr>

    </table>
    <table className="tabla-programas">
            
            <caption>3er Año</caption>
    <tr>

      <th>Materia</th>
      <th>Programa</th>

    </tr>
    <tr>

      <td>Lengua y Literatura</td>
      <td><a href="https://drive.google.com/drive/folders/1dTz2Syt9b9AuCPdLsRwaQ0QZb5yl_0wN?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Matematica</td>
      <td><a href="https://drive.google.com/drive/folders/1b7sKRdTgmGLXWb1mwJddXmpsFXSh8zin?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Idioma Extranjero Ingles o Frances</td>
      <td><a href="https://drive.google.com/drive/folders/1UnB_Mtq1nCF0_wdGFH0t1RRcFOJAC1KJ?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Ciencias Biologicas</td>
      <td><a href="https://drive.google.com/drive/folders/1CiafrkrzymZRQvKDDiHtsNyEuYXQTPQP?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Edicacion Plastica</td>
      <td><a href="https://drive.google.com/drive/folders/1ZgCo8i_M49vpjNS1SwdT9ScOpznyOOhD?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Geografia</td>
      <td><a href="https://drive.google.com/drive/folders/18TjG7-qtvRb7QZN9y2DpORLrxcbxyV-2?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Educacion Civica</td>
      <td><a href="https://drive.google.com/drive/folders/16AH_QNCJG78APfX6my2qH_ZYKGGCK27E?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Historia</td>
      <td><a href="https://drive.google.com/drive/folders/138audBMsEWbWG1XlCp1vjHs2URSBsYAS?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Fisica</td>
      <td><a href="https://drive.google.com/drive/folders/1sE9RyfnvQWDiiYqi3TGEDDXWrPUQmqGM?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Quimica</td>
      <td><a href="https://drive.google.com/drive/folders/1onBIP7plglne3vwvdKgISc2TYNAeFUtS?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Contabilidad</td>
      <td><a href="https://drive.google.com/drive/folders/16nCj11yEKtwcg9uW2jp6LZ_9GVIsrT1h?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Mecanografia</td>
      <td><a href="https://drive.google.com/drive/folders/19jsTQUleux3FCIxQQN-tDoQoclGQFFTV?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>
    
    <tr>

      <td>Educacion Fisica</td>
      <td><a href="https://drive.google.com/drive/folders/1Qazxu7QIyypaGzUT4ek_onYcekWfQOqB?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>

    </tr>

  </table>
  
    </div>
        
    </div>
  )
}

export default PlanViejo